import React from "react"


const HomeComponent = React.lazy(()=> import("./Home"))
const AboutComponent = React.lazy(()=> import("./About"))
const BlogsComponent = React.lazy(()=> import("./Blogs"))
const BlogsDetailComponent = React.lazy(()=> import("./BlogsDetail"))
const CareerComponent = React.lazy(()=> import("./Career"))
const CareerDetailComponent = React.lazy(()=> import("./CareerDetail"))
const ContactUsComponent = React.lazy(()=> import("./ContactUs"))
const ServicesComponent = React.lazy(()=> import("./Services"))
const LoginComponent = React.lazy(()=> import("../components/AdminBlog/Login"))
const DashBoardComponent = React.lazy(()=> import("./Admin/AdminDashboard"))
const AdminCareer = React.lazy(()=> import("./Admin/career/Career"))
const AdminBlog = React.lazy(()=> import("./Admin/Blogs/Blog"))
const SubmitDetail = React.lazy(()=> import("./Admin/career/submitDetail/SubmitDetail"))
const EachApplicant = React.lazy(()=> import("./Admin/career/submitDetail/EachApplicant"))
const Closed = React.lazy(()=> import("./Admin/career/submitDetail/Closed"))
const Admins= React.lazy(()=> import("./Admin/Admins/Admins"))

const pages = [
  {
    name: "Home",
    route: "/",
    element: <HomeComponent />
  },
  {
    name: "About",
    route: "/about",
    element: <AboutComponent />
  },
  {
    name: "Services",
    route: "/services",
    element: <ServicesComponent />
  },
  {
    route: "/blogs/:id",
    element: <BlogsDetailComponent />
  },
  {
    name: "Contact",
    route: "/contact",
    element: <ContactUsComponent />
  },
  {
    name: "Career",
    route: "/career",
    element: <CareerComponent/>
  },
  {
    route: "/career/:id",
    element: <CareerDetailComponent />
  },
  {
    name: "Blogs",
    route: "/blogs",
    element: <BlogsComponent />
  },
  {
    name: "login",
    route: "/admin/login",
    element: <LoginComponent />
  },
]


export default pages

export const protectedPages = [
  {
    name: "dashboard",
    route: "/admin/dashboard",
    element: <DashBoardComponent />
  },
  {
    name: "career",
    route: "/admin/post_Jobs",
    element: <AdminCareer />
  },
  {
    name: "blog",
    route: "/admin/create_blog",
    element: <AdminBlog />
  },
  {

    route: `/admin/submitted/:title`,
    element: <SubmitDetail />
  },
  {
    route: `/admin/application/:name`,
    element: <EachApplicant />
  },
  {
    route: `/admin/closed/:title`,
    element: <Closed />
  },
  
  {
    name: "admins",
    route: "/admin/admins",
    element: <Admins />
  }
]